import { ResourceOptions } from 'react-admin';
import { FaTachometerAlt } from 'react-icons/fa';
import { Resources } from '../../resource';

export { default as list } from './List';

export const name = Resources.socialTradingWorkbench;
export const icon = FaTachometerAlt;
export const options: ResourceOptions = {
  label: 'module.socialTrading.workbench',
};
